import {Component, HostListener, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {GameSize} from "./game-size.service";
import {GameInput} from "./game-input.service";
import {GameCredits} from "./game-credits.service";

@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.css']
})
export class GameComponent implements OnInit, OnChanges {
  @Input() aspectRatio = 3/2;
  @Input() widthPart = 0.9;
  @Input() heightPart = 0.7;
  @Input() allowFlip = false;

  constructor(
    private gameSize: GameSize,
    private gameInput: GameInput,
    public gameCredits: GameCredits
    ) {
    this.passChanges();
  }

  private passChanges() {
    this.gameSize.aspectRatio = this.aspectRatio;
    this.gameSize.widthPart = this.widthPart;
    this.gameSize.heightPart = this.heightPart;
    this.gameSize.allowFlip = this.allowFlip;
  }

  ngOnInit(): void {
    this.gameSize.innerWidth = window.innerWidth;
    this.gameSize.innerHeight = window.innerHeight;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.gameSize.innerWidth = event.target.innerWidth;
    this.gameSize.innerHeight = event.target.innerHeight;
  }

  @HostListener('document:keydown', ['$event'])
  onKey(ev: KeyboardEvent): void {
    this.gameInput.onKey(ev);
  }

  @HostListener('document:keyup', ['$event'])
  onKeyUp(ev: KeyboardEvent): void {
    this.gameInput.onKeyUp(ev);
  }

  get style(): any {
    return {
      width: `${this.gameSize.width}px`
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.passChanges();
  }
}

